import { Navigate } from 'react-router-dom'
import useAppMode from './useAppMode'
import { fieldRoutes } from 'constants/fieldRoutes'

/**
 * What `/` renders: the field app or the desktop home.
 *
 * The decision is made once here rather than scattered through the screens, and
 * it reads a stored preference before falling back to the device class — so a
 * user who has chosen stays chosen, and an iPad does not change apps when it is
 * rotated.
 *
 * `replace` so the redirect does not sit in history: with the app installed
 * there is no browser back button, but in a tab a user pressing back should
 * leave the app rather than bounce off `/` forever.
 */
const AppEntry = ({ desktop }: { desktop: React.ReactNode }) => {
	const { mode } = useAppMode()

	if (mode === 'field') return <Navigate to={fieldRoutes.HOME} replace />
	return <>{desktop}</>
}

export default AppEntry
